export const ActionType = {
  SET_MEALS: "SET_MEALS",
  SELECTED_MEAL: "SELECTED_MEAL",
  REMOVE_SELECTED_MEAL: "REMOVE_SELECTED_MEAL",
}